/* @flow */
import * as React from "react";
import type Device from "nexia_mobile/models/device";
import Environment from "nexia_mobile/environment";

type Props = {
  model: Device,
  children: ({
    setpointCoolMin: number,
    setpointCoolMax: number,
    setpointHeatMin: number,
    setpointHeatMax: number,
  }) => React.Node,
};

type State = {
  setpointCoolMin: number,
  setpointCoolMax: number,
  setpointHeatMin: number,
  setpointHeatMax: number,
};

export default class OccupanySetpointController extends React.Component<
  Props,
  State
> {
  state = {
    setpointCoolMin: this.props.model.get("setpoint_cool_min"),
    setpointCoolMax: this.props.model.get("setpoint_cool_max"),
    setpointHeatMin: this.props.model.get("setpoint_heat_min"),
    setpointHeatMax: this.props.model.get("setpoint_heat_max"),
  };
  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    this.updateMinMaxSetpoint(nextProps);
  }

  updateMinMaxSetpoint(props: Props) {
    const { model } = props;
    const occupancyMode = this.getOccupancyMode(props);
    const setpointCoolMin = model.get("setpoint_cool_min");
    const setpointCoolMax = model.get("setpoint_cool_max");
    const setpointHeatMin = model.get("setpoint_heat_min");
    const setpointHeatMax = model.get("setpoint_heat_max");

    if (occupancyMode && occupancyMode !== "occupied") {
      this.setState({
        setpointCoolMin: model.get("setpoint_cool"),
        setpointCoolMax: model.get("setpoint_cool"),
        setpointHeatMin: model.get("setpoint_heat"),
        setpointHeatMax: model.get("setpoint_heat"),
      });
    } else if (this.shouldResetSetpointMinMax()) {
      const occupancy = model.get("occupancy_setpoints");
      if (occupancy) {
        this.setState({
          setpointCoolMin: this.limitedMinSetpoint(
            occupancy.preset_cool1,
            setpointCoolMin
          ),
          setpointCoolMax: this.limitedMaxSetpoint(
            occupancy.preset_cool1,
            setpointCoolMax
          ),
          setpointHeatMin: this.limitedMinSetpoint(
            occupancy.preset_heat1,
            setpointHeatMin
          ),
          setpointHeatMax: this.limitedMaxSetpoint(
            occupancy.preset_heat1,
            setpointHeatMax
          ),
        });
      } else {
        this.setState({
          setpointCoolMin,
          setpointCoolMax,
          setpointHeatMin,
          setpointHeatMax,
        });
      }
    } else {
      this.setState({
        setpointCoolMin,
        setpointCoolMax,
        setpointHeatMin,
        setpointHeatMax,
      });
    }
  }

  getOccupancyMode(props: Props) {
    const { model } = props;
    if (Environment.isCommercial()) {
      const occupancyMode = model.get("occupancy_mode");
      return occupancyMode ? occupancyMode.toLowerCase() : null;
    }
    return null;
  }

  shouldResetSetpointMinMax() {
    const { model } = this.props;
    const occupancy = model.get("occupancy_setpoints");
    if (occupancy) {
      const setpointLimitEnabled = occupancy.setpoint_limit_enabled;
      return (
        setpointLimitEnabled && this.getOccupancyMode(this.props) === "occupied"
      );
    }
    return false;
  }

  limitedMinSetpoint(value: number, minValue: number) {
    const occupancy = this.props.model.get("occupancy_setpoints");
    if (occupancy) {
      const setpointLimit = occupancy.setpoint_limit;
      let minSetpoint = value - setpointLimit;
      if (minSetpoint < minValue) {
        return minValue;
      } else {
        return minSetpoint;
      }
    }
    return value;
  }

  limitedMaxSetpoint(value: number, maxValue: number) {
    const occupancy = this.props.model.get("occupancy_setpoints");
    if (occupancy) {
      const setpointLimit = occupancy.setpoint_limit;
      let maxSetpoint = value + setpointLimit;
      if (maxSetpoint > maxValue) {
        return maxValue;
      } else {
        return maxSetpoint;
      }
    }
    return value;
  }

  render() {
    const { children } = this.props;
    const occupancyMode = this.getOccupancyMode(this.props);
    const {
      setpointCoolMin,
      setpointCoolMax,
      setpointHeatMin,
      setpointHeatMax,
    } = this.state;
    return children({
      setpointCoolMin,
      setpointCoolMax,
      setpointHeatMin,
      setpointHeatMax,
      occupancyMode,
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/Controls/Thermostat/OccupanySetpointController.jsx